﻿import { CacheCommand, CacheQuery } from './cache';
import { CommentCommand, CommentQuery } from './comment';
import { GeneralQuery } from './general';
import { OperatorQuery } from './operator';
import { CustomerQuery, CustomerCommand } from './customer';
import { StoreQuery } from './store';
import { MenuCommand, MenuQuery } from './menu';
import { OmnichannelQuery, OmnichannelCommand } from './omnichannel';
import { CargoQuery, CargoCommand } from './cargo';
import { BillingCommand, BillingQuery } from './billing';
import { ShippingPerformanceQuery, ShippingPerformanceCommand } from './shippingPerformance';
import { BinNumberManagementQuery, BinNumberManagementCommand } from './binNumberManagement/binNumberManagement-urls';
import { OrderCommand, OrderQuery } from './order';
import { ReturnCommand, ReturnQuery } from './return';
import { OfsLogsCommand } from './ofsLogs';
import { LocalizationManagementQuery } from './localizationManagement';
import { EmailAndSmsServiceLogsQuery } from './emailandsmsservicelogs';
import { PaymentQuery, PaymentCommand } from './payment';
import { OperatorCommand } from './operator/operatorCommand';
import { DesignCollectiveQuery, DesignCollectiveCommand } from './designcollective';
import { MobilePanelConfigurationCommand, MobilePanelConfigurationQuery } from './mobilepanelconfiguration';
import {
    MobilePanelClientTranslationsCommand,
    MobilePanelClientTranslationsQuery,
} from './mobilePanelClientTranslations';
import { LcwMoneyCommand, LcwMoneyQuery } from './lcwMoney';
import { SearchServiceCommand, SearchServiceQuery } from './searchService';
import { RetailCommand } from './retail';
import { ProductTransferQuery } from './productTransfer/productTransferQuery';
import { ProductTransferCommand } from './productTransfer';
import { ReportsCommand, ReportsQuery } from './reports';
import { OrderFraudControlQuery } from './orderFraudControl';
import { SmsTemplateCommand, SmsTemplateQuery } from './smsTemplate';
import { LocalizationManagementCommand } from './localizationManagement';
import { ProductSearchServiceCommand, ProductSearchServiceQuery } from './productSearch';
import { ProductDetailServiceQuery } from './productDetail';
import { StoreReturnCommand, StoreReturnQuery } from './storeReturn';
import { DataQuery } from './data';
import { RefundQuery } from './refund';
import { ImageSearchServiceQuery } from './imageSearch';
import { ImageSearchV2ServiceQuery } from './imageSearchV2';
import { HarmonyQuery } from './harmony';
import { ShippingQuery, ShippingCommand } from './shipping';
import { CargoManagementQuery, CargoManagementCommand } from './cargoManagement';
import { GreetingNotesCommand, GreetingNotesQuery } from './greetingNotes';
import { CargoFeeManagementCommand, CargoFeeManagementQuery } from './cargoFeeManagement';
import { EmailTemplateBuilderQuery, EmailTemplateBuilderCommand } from './emailTemplateBuilder';
import { DynamicRequestQuery } from './dynamicRequest';
import { RuleServiceCommand, RuleServiceQuery } from './ruleservice';
import { PostCheckoutQuery, PostCheckoutCommand } from './postCheckout';
import { CompleteAndConfirmQuery, CompleteAndConfirmCommand } from './completeAndConfirm';
import { CampaignManagementCommand, CampaignManagementQuery } from './campaignManagement';
import { ProductServiceCommand } from './product/productServiceCommand';
import { SaleServiceCommand } from './sale';
import { RefundRestQuery } from './refundRest';
import { YdReturnQuery } from './ydMp';
import { TestPingQuery } from './testPing';
import { RpaQuery } from './rpa';
import { CookieManagementCommand, CookieManagementQuery } from './cookieManagement';
import { ExpenseNoteQuery } from './expenseNote';
import { AuthQuery } from './auth';
import { GlobaldataCommand, GlobaldataQuery } from './globaldata';
import { CargoPrioritizationCommand, CargoPrioritizationQuery } from './cargoPrioritization';
import { PaymentConsolidationQuery } from './paymentConsolidation';
import { GiftVoucherQuery } from './giftVoucher';
import { CargoEstimationCommand } from './cargoEstimation';
import { ScheduleServiceCommand } from './scheduleService';
import { ScheduleServiceQuery } from './scheduleService';
import { ScheduleGroupsQuery, ScheduleGroupCommand } from './scheduleGroups';
import { OrderPrioCommand, OrderPrioQuery } from './orderPrio';
import { GoalQuery } from './goal/goalQuery';
import { LostCargoCommand, LostCargoQuery } from './lostCargo';
import { JsonBuilderQuery, JsonBuilderCommand } from './jsonBuilder';
import { StorePickupPackageCommand, StorePickupPackageQuery } from './storePickupPackage';
import { StudioCommandURLs, StudioQueryURLs } from './studio';
import { SummaryQuery, SummaryCommand } from './summary';
import { FastDeliveryCargoManagementCommand, FastDeliveryCargoManagementQuery } from './fastDeliveryCargoManagement';
import { MobileAppHandlerCommand, MobileAppHandlerQuery } from './mobileapphandler';
import { NoOrderShotSearchQuery } from './noOrderShotSearch';
import { ProductShotHistoryQuery } from './productShotHistory';
import { DeliveryQuery } from './delivery';
import { MasterDataQuery } from './masterData';
import { MasterDataCommand } from './masterData';
import { MPPaymentOnDeliveryCommissionQuery } from './mpPaymentOnDeliveryCommission';
import { MPPaymentOnDeliveryCommissionCommand } from './mpPaymentOnDeliveryCommission';
import { HiddenExcelCommand } from './hiddenExcel/hiddenExcelCommand';
import { HiddenExcelQuery } from './hiddenExcel/hiddenExcelQuery';
import { GrowManagementCommand, GrowManagementQuery } from './growManagement';
import { GiftCardQuery } from './giftCard';
import { AuditLogsQuery } from './auditLogs/auditQuery';
import { IpWhiteListCommand, IpWhiteListQuery } from './ipWhiteList';
import { SyncTableStateCommand, SyncTableStateQuery } from './syncTableState';
import { CutOffQuery, CutOffCommand } from './cutOff';
import { JiraTrackerQuery, JiraTrackerCommand } from './jiraTracker/jiraTracker-urls';
import { OtpPasswordQuery, OtpPasswordCommand } from './otpPassword';
import { GlobalSmsRateLimitQuery, GlobalSmsRateLimitCommand } from './globalSmsRateLimit';
import { CargoAddressBlockingQuery, CargoAddressBlockingCommand } from './cargoAddressBlocking';
import { StoreCargoBlockingQuery, StoreCargoBlockingCommand } from './storeCargoBlocking';
import {
    CargoCompanyDistributionAreasQuery,
    CargoCompanyDistributionAreasCommand,
} from './cargoCompanyDistributionAreas';
import { TaskAnalyzerCommandUrl } from './taskAnalyzer';
import { SummaryCommandV2 } from './summaryV2';
import { StoreCustomerManagementQuery, StoreCustomerManagementCommand } from './storeCustomerManagement';
import { SellerPortalProductQuery } from './sellerPortalProduct';
import { CategoryRestrictionQuery, CategoryRestrictionCommand } from './categoryRestriction';
import { StoreManagerPermissionQuery, StoreManagerPermissionCommand } from './storeManagerPermission';
import { SummaryAggregationQuery } from './summaryAggregation';
import { AutoReturnAndResendUrls } from './autoReturnAndResend/autoReturnAndResendUrls';
import { RuntimeConfigurationQuery, RuntimeConfigurationCommand } from './runtimeConfiguration/runtimeConfiguration-urls';
import { WorkAssignmentCommandURL, WorkAssignmentQueryURL } from './workAssignment';
import { PaylensQuery } from './paylens/paylensQuery';
const ApiBaseURL: any = import.meta.env.VITE_APIURL;

class ApiURL {
    static Query = {
        StudioQueryURLs,
        WorkAssignmentQueryURL,
        ...BillingQuery,
        ...CampaignManagementQuery,
        ...CargoQuery,
        ...CustomerQuery,
        ...DataQuery,
        ...OmnichannelQuery,
        ...CacheQuery,
        ...CommentQuery,
        ...GeneralQuery,
        ...MenuQuery,
        ...OperatorQuery,
        ...StoreQuery,
        ...PaymentQuery,
        ...DesignCollectiveQuery,
        ...MobilePanelConfigurationQuery,
        ...MobilePanelClientTranslationsQuery,
        ...LcwMoneyQuery,
        ...ShippingPerformanceQuery,
        ...SearchServiceQuery,
        ...OrderQuery,
        ...ReturnQuery,
        ...ProductTransferQuery,
        ...ReportsQuery,
        ...OrderFraudControlQuery,
        ...SmsTemplateQuery,
        ...LocalizationManagementQuery,
        ...EmailAndSmsServiceLogsQuery,
        ...ProductSearchServiceQuery,
        ...ProductDetailServiceQuery,
        ...StoreReturnQuery,
        ...RefundQuery,
        ...CargoManagementQuery,
        ...ImageSearchServiceQuery,
        ...ImageSearchV2ServiceQuery,
        ...GreetingNotesQuery,
        ...HarmonyQuery,
        ...RuleServiceQuery,
        ...ShippingQuery,
        ...CargoFeeManagementQuery,
        ...EmailTemplateBuilderQuery,
        ...DynamicRequestQuery,
        ...PostCheckoutQuery,
        ...CompleteAndConfirmQuery,
        ...RefundRestQuery,
        ...YdReturnQuery,
        ...TestPingQuery,
        ...PaylensQuery,
        ...RpaQuery,
        ...CookieManagementQuery,
        ...ExpenseNoteQuery,
        ...AuthQuery,
        ...GlobaldataQuery,
        ...CargoPrioritizationQuery,
        ...PaymentConsolidationQuery,
        ...GiftVoucherQuery,
        ...ScheduleServiceQuery,
        ...ScheduleGroupsQuery,
        ...OrderPrioQuery,
        ...GoalQuery,
        ...LostCargoQuery,
        ...JsonBuilderQuery,
        ...StorePickupPackageQuery,
        ...SummaryQuery,
        ...FastDeliveryCargoManagementQuery,
        ...MobileAppHandlerQuery,
        ...NoOrderShotSearchQuery,
        ...ProductShotHistoryQuery,
        ...DeliveryQuery,
        ...MasterDataQuery,
        ...MPPaymentOnDeliveryCommissionQuery,
        ...HiddenExcelQuery,
        ...BinNumberManagementQuery,
        ...GrowManagementQuery,
        ...AuditLogsQuery,
        ...CutOffQuery,
        ...IpWhiteListQuery,
        ...SyncTableStateQuery,
        ...OtpPasswordQuery,
        ...GlobalSmsRateLimitQuery,
        ...CargoAddressBlockingQuery,
        ...StoreCargoBlockingQuery,
        ...CargoCompanyDistributionAreasQuery,
        ...GiftCardQuery,
        ...JiraTrackerQuery,
        ...StoreCustomerManagementQuery,
        ...SellerPortalProductQuery,
        ...CategoryRestrictionQuery,
        ...StoreManagerPermissionQuery,
        ...SummaryAggregationQuery,
        ...AutoReturnAndResendUrls,
        ...RuntimeConfigurationQuery,
    };

    static Command = {
        WorkAssignmentCommandURL,
        StudioCommandURLs,
        ...OfsLogsCommand,
        ...CustomerCommand,
        ...ReturnCommand,
        ...BillingCommand,
        ...CargoCommand,
        ...CacheCommand,
        ...OmnichannelCommand,
        ...MenuCommand,
        ...OperatorCommand,
        ...CommentCommand,
        ...DesignCollectiveCommand,
        ...MobilePanelConfigurationCommand,
        ...MobilePanelClientTranslationsCommand,
        ...LcwMoneyCommand,
        ...ShippingPerformanceCommand,
        ...SearchServiceCommand,
        ...OrderCommand,
        ...RetailCommand,
        ...ProductTransferCommand,
        ...SmsTemplateCommand,
        ...LocalizationManagementCommand,
        ...ReportsCommand,
        ...PaymentCommand,
        ...RuleServiceCommand,
        ...ProductSearchServiceCommand,
        ...StoreReturnCommand,
        ...CargoManagementCommand,
        ...GreetingNotesCommand,
        ...CargoFeeManagementCommand,
        ...PostCheckoutCommand,
        ...CompleteAndConfirmCommand,
        ...EmailTemplateBuilderCommand,
        ...CampaignManagementCommand,
        ...ProductServiceCommand,
        ...SaleServiceCommand,
        ...CookieManagementCommand,
        ...GlobaldataCommand,
        ...CargoPrioritizationCommand,
        ...CargoEstimationCommand,
        ...ScheduleServiceCommand,
        ...ScheduleGroupCommand,
        ...OrderPrioCommand,
        ...LostCargoCommand,
        ...JsonBuilderCommand,
        ...StorePickupPackageCommand,
        ...SummaryCommand,
        ...FastDeliveryCargoManagementCommand,
        ...MobileAppHandlerCommand,
        ...ShippingCommand,
        ...MasterDataCommand,
        ...MPPaymentOnDeliveryCommissionCommand,
        ...HiddenExcelCommand,
        ...BinNumberManagementCommand,
        ...GrowManagementCommand,
        ...CutOffCommand,
        ...IpWhiteListCommand,
        ...SyncTableStateCommand,
        ...OtpPasswordCommand,
        ...GlobalSmsRateLimitCommand,
        ...CargoAddressBlockingCommand,
        ...StoreCargoBlockingCommand,
        ...CargoCompanyDistributionAreasCommand,
        ...SummaryCommandV2,
        TaskAnalyzerCommandUrl,
        ...StoreCustomerManagementCommand,
        ...CategoryRestrictionCommand,
        ...StoreManagerPermissionCommand,
        ...JiraTrackerCommand,
        ...AutoReturnAndResendUrls,
        ...RuntimeConfigurationCommand,
    };
}
export { ApiBaseURL, ApiURL };
